<template>
	<div>
		<!-- MOCK: for aeg_uat, aeg we are mocking CMS for policies list -->
		<template
			v-if="
				$store.state.tenantId === 'aeg_uat' ||
					$store.state.tenantId === 'aeg' ||
					$store.state.tenantId === 'demo_uat' ||
					$store.state.tenantId === 'bupa_uat' ||
					$store.state.tenantId === 'apeiron_uat'
			"
		>
			<aeg-policy-list />
		</template>

		<!-- MOCK: for asia_uat show Asia listing -->
		<!-- TODO: when good for production, show also for asia tenant -->
		<template
			v-else-if="
				$store.state.tenantId === 'asia_uat' ||
					$store.state.tenantId === 'asia' ||
					$store.state.tenantId === 'aia_uat'
			"
		>
			<asia-policy-list />
		</template>

		<!-- MOCK: for berkley_uat show berkley listing -->
		<template v-else-if="$store.state.tenantId === 'berkley_uat'">
			<berkley-policy-list />
		</template>

		<!-- MOCK: for HKECIC -->
		<template
			v-else-if="
				$store.state.tenantId === 'hkecic_uat' ||
					$store.state.tenantId === 'hkecic'
			"
		>
			<hkecic-policy-list />
		</template>

		<!-- MOCK: for FiLife -->
		<template
			v-else-if="
				$store.state.tenantId === 'fiLife_uat' ||
					$store.state.tenantId === 'fiLife'
			"
		>
			<fi-life-policy-list />
		</template>

		<!-- MOCK: for Demo_2 -->
		<template
			v-else-if="
				$store.state.tenantId === 'demo2_uat' ||
					$store.state.tenantId === 'demo2'
			"
		>
			<demo-2-policy-list />
		</template>

		<!-- MOCK: for Zurich -->
		<template
			v-else-if="
				$store.state.tenantId === 'zurich_uat' ||
					$store.state.tenantId === 'zurich'
			"
		>
			<zurich-policy-list />
		</template>

		<!-- MOCK: for digitalBroker -->
		<template
			v-else-if="
				$store.state.tenantId === 'digitalBroker' ||
					$store.state.tenantId === 'companyCover_uat'
			"
		>
			<digital-broker-policy-list />
		</template>

		<!-- 
			MOCK: all other tenants have default
			Old tenants that have old flow with quote and policy being the same
			we are filtering policies based on status differently than for new tenants
			because there is a difference what is default status when policy is generated
		-->
		<template v-else>
			<default-policy-list></default-policy-list>
		</template>
	</div>
</template>

<script>
import DefaultPolicyList from "../components/mockedCms/DefaultPolicyList"
import AegPolicyList from "../components/mockedCms/AegPolicyList"
import BerkleyPolicyList from "../components/mockedBerkley/BerkleyPolicyList"
import HkecicPolicyList from "../components/mockedHKECIC/HkecicPolicyList"
import FiLifePolicyList from "../components/mockedFiLife/FiLifePolicyList"
import Demo2PolicyList from "../components/mockedDemo2/Demo2PolicyList"
import ZurichPolicyList from "../components/mockedZurich/ZurichPolicyList"
import DigitalBrokerPolicyList from "../components/mockedDigitalBroker/DigitalBrokerPolicyList"
import AsiaPolicyList from "../components/mockedAsia/AsiaPolicyList"

export default {
	components: {
		DefaultPolicyList,
		AegPolicyList,
		BerkleyPolicyList,
		HkecicPolicyList,
		Demo2PolicyList,
		FiLifePolicyList,
		ZurichPolicyList,
		DigitalBrokerPolicyList,
		AsiaPolicyList
	},

	beforeRouteLeave(to, from, next) {
		// If in same module , do nothing, do not reset page
		if (to.meta.featureId === from.meta.featureId) {
			next()
		} else {
			// if not in same module, reset page to 1
			this.$store.commit("policies/SET_PAGE", 1)
			// Turn filter off and clear filters
			this.$store.commit("policies/SET_FILTER_IS_FILTERING", false)

			// clear search
			this.$store.commit("policies/SET_SEARCH_TERM", null)
			this.$store.commit("policies/SET_PAGE", 1)
			this.$store.commit("policies/SET_FILTER_PAYLOAD", null)
			this.$store.commit("policies/SET_FILTER_WHERE", null)
			next()
		}
	}
}
</script>
